define.alias("shared/components/shared/ui/report/settings", "calendar/components/shared/ui/report/settings");